import { render, staticRenderFns } from "./ArchiveConfirm.vue?vue&type=template&id=26a1b192&scoped=true"
import script from "./ArchiveConfirm.vue?vue&type=script&lang=js"
export * from "./ArchiveConfirm.vue?vue&type=script&lang=js"
import style0 from "./ArchiveConfirm.vue?vue&type=style&index=0&id=26a1b192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a1b192",
  null
  
)

export default component.exports